import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import { initSelectA11y } from './plugins/selectA11y'
import {supabase} from './supabase'
import '@toast-ui/editor/dist/toastui-editor.css';
import '@toast-ui/editor/dist/toastui-editor-viewer.css';

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App),
  created () {
    supabase.auth.onAuthStateChange(async (event) => {
      if (event == 'SIGNED_IN') {
          // const { data: { user } } = await supabase.auth.getUser()
          supabase.auth.getUser().then(async ({ data: { user } }) => {
            if (user.app_metadata.requires_mfa) {
              
              const { data: aal } = await supabase.auth.mfa.getAuthenticatorAssuranceLevel()

              if (aal && aal.currentLevel === 'aal2') {
                store.commit('SET_VERIFY_TOTP', false)
                store.commit('SET_SETUP_TOTP', false)
              } else {
                const hasVerifiedMfa = user.factors?.some(factor=>factor.status === 'verified') ?? false
                
                if(hasVerifiedMfa) {
                  store.commit('SET_VERIFY_TOTP', true)
                  store.commit('SET_SETUP_TOTP', false)
                } else {
                  store.commit('SET_SETUP_TOTP', true)
                  store.commit('SET_VERIFY_TOTP', false)
                }
              }
            }
          })
          store.commit('SET_LOGGED_IN', true)
          store.dispatch('getUser')
      }
      if (event == 'SIGNED_OUT') {
          store.commit('SET_LOGGED_IN', false)
          store.commit('SET_USER', null)
          // store.commit('setUserLoading', true)
          
      }
    })
  }
}).$mount('#app')

initSelectA11y()
